export type ApiError = { detail?: unknown };

export function isFieldLevelError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const detail = (error as ApiError).detail;
  return !!detail && typeof detail === "object" && !Array.isArray(detail);
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (!error || typeof error !== "object") return fallback;
  const detail = (error as ApiError).detail;
  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }
  return fallback;
}
